<template>
  <base-input
    v-bind="props"
    autocomplete="off"
    :type="hidePassword ? 'password' : 'text'"
    @update:model-value="$emit('update:modelValue', $event)"
    :rules="props.rules"
    :hint="props.noHint ? '' : '半角英数字と『!%&@#$?』の記号が利用できます。<br>8～32文字で、大文字・小文字・数字を1文字以上使用してください。'"
  >
    <template #append-inner>
      <base-icon v-if="hidePassword" class="clickable" name="eye-closed" fill="primary" @click="toggleHidePassword"/>
      <base-icon v-else class="clickable" name="eye-open" fill="primary" @click="toggleHidePassword"/>
    </template>
  </base-input>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import BaseInput from '@/components/Forms/BaseInput.vue';
import BaseIcon from '@/components/Images/BaseIcon.vue';
import {ValidatorRule} from "@/composable/ui/useForm";

const props = defineProps(
  {
    label: { type: String, default: 'パスワード' },
    modelValue: [String],
    placeholder: String,
    rules: {
      type: Array as () => ValidatorRule<string>[],
      default: () => [],
    },
    requiredTag: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noError: {
      type: Boolean,
      default: false,
    },
    noHint: {
      type: Boolean,
      default: false,
    },
  },
);
const emit = defineEmits(['update:modelValue']);

const hidePassword = ref(true);

function toggleHidePassword() {
  hidePassword.value = !hidePassword.value;
}
</script>

<style scoped>

</style>
